// extracted by mini-css-extract-plugin
export default {"cls1":"TypeWriter-cls1_dnk","cls2":"TypeWriter-cls2_WOZ TypeWriter-cls1_dnk"};